import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import ShopThisLook from "../ProductsCollection/ShopThisLook";
import ShareDesktop from "../Share/ShareDesktop";
import ShareMobile from "../Share/ShareMobile";
import { LAYOUT } from "../../configuration/theme";

const MEDIA_FRAME_RATIO = "3 / 4";

const PostDetail = ({ content, posted, products, userId, headingLevel = "h2", children }) => {
    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
    const [openShare, setOpenShare] = useState(false);


    return (
        <>
            <Container sx={{ px: LAYOUT.pagePad }}>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 520px) minmax(0, 1fr)" },
                        gap: "40px",
                        alignItems: "start",
                        pt: "32px",
                        pb: "48px",
                    }}
                >
                    <Box
                        data-testid={"tvp-media-frame"}
                        sx={{
                            position: "relative",
                            backgroundColor: "#000",
                            borderRadius: (theme) => theme.tvp.radiusMedia,
                            overflow: "hidden",
                            aspectRatio: MEDIA_FRAME_RATIO,
                            maxHeight: "calc(100vh - 190px)",
                            "& video": { width: "100%", height: "100%", objectFit: "cover" },
                        }}
                    >
                        {children}
                    </Box>

                    <Box sx={{ minWidth: 0 }}>
                        <Typography
                            component={headingLevel}
                            sx={{ fontSize: "26px", fontWeight: 700, lineHeight: 1.25, letterSpacing: "-0.3px", margin: "0 0 8px" }}
                        >
                            {content.title}
                        </Typography>
                        {posted && (
                            <Box sx={{ fontSize: "12.5px", color: "#666666", marginBottom: "12px" }}>{posted}</Box>
                        )}
                        {content.description && (
                            <Typography sx={{ fontSize: "15px", lineHeight: 1.55, color: "#202020", margin: "0 0 20px" }}>
                                {content.description}
                            </Typography>
                        )}
                        <Box
                            component={"button"}
                            type={"button"}
                            onClick={() => setOpenShare(true)}
                            sx={{
                                cursor: "pointer",
                                backgroundColor: "#fff",
                                border: "1px solid #D8D8D8",
                                color: "#202020",
                                borderRadius: (theme) => theme.tvp.radiusCtl,
                                height: "40px",
                                lineHeight: "38px",
                                padding: "0 18px",
                                margin: 0,
                                fontSize: "14px",
                                marginBottom: "28px",
                                boxSizing: "border-box",
                                flex: "none",
                                transition: "border-color 120ms ease",
                                "&:hover": { border: "1px solid #202020", backgroundColor: "#fff", color: "#202020" },
                            }}
                        >
                            Share
                        </Box>
                        <ShopThisLook products={products} userId={userId} contentId={content.id} />
                    </Box>
                </Box>
            </Container>
            {mobileView && openShare && (
                <ShareMobile isOpen={openShare} handleClose={() => setOpenShare(false)} content={content} />
            )}
            {!mobileView && openShare && (
                <ShareDesktop isOpen={openShare} handleClose={() => setOpenShare(false)} content={content} />
            )}
        </>
    );
};

PostDetail.propTypes = {
    content: PropTypes.object.isRequired,
    posted: PropTypes.string,
    products: PropTypes.array,
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    headingLevel: PropTypes.oneOf(["h1", "h2"]),
};

export default PostDetail;
